import script from "./TimeDisplay.vue?vue&type=script&setup=true&lang=ts"
export * from "./TimeDisplay.vue?vue&type=script&setup=true&lang=ts"

import "./TimeDisplay.vue?vue&type=style&index=0&id=63a76c3e&lang=css"

const __exports__ = script;

export default __exports__